<header>
  <nav
    class="
      navbar navbar-expand-sm navbar-toggleable-sm navbar-light
      bg-white
      border-bottom
      box-shadow
      mb-3
    "
  >
    <div class="container-fluid">
      <a class="navbar-brand" [routerLink]="['/']">Nueva.Web</a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target=".navbar-collapse"
        aria-label="Toggle navigation"
        [attr.aria-expanded]="isExpanded"
        (click)="toggle()"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="navbar-collapse collapse d-sm-inline-flex justify-content-end"
        [ngClass]="{ show: isExpanded }"
      >
        <ul class="navbar-nav">
          <li
            class="nav-item"
            *ngIf="authorizationService.authenticated | async"
            [routerLinkActive]="['link-active']"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a class="nav-link text-dark" [routerLink]="['/']">Stocks</a>
          </li>
        </ul>

        <ul class="navbar-nav">
          <li
            class="nav-item"
            *ngIf="authorizationService.authenticated | async"
            [routerLinkActive]="['link-active']"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a class="nav-link text-dark" [routerLink]="['/filters']"
              >Filters</a
            >
          </li>
        </ul>
        <ul
          class="navbar-nav"
          *ngIf="
            (authorizationService.authenticated | async) &&
            (mainHubeService.needAmeritradeLogin | async)
          "
        >
          <li
            class="nav-item"
            [routerLinkActive]="['link-active']"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <button class="btn btn-primary mr-2" (click)="loginToAmeritrade()">
              Login to Ameritrade
            </button>
          </li>
        </ul>

        <ul
          class="navbar-nav"
          *ngIf="authorizationService.authenticated | async"
        >
          <li
            class="nav-item"
            [routerLinkActive]="['link-active']"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <button class="btn btn-primary" (click)="logout()">Logout</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
